import { useSponsoredContent } from "../useSponsoredContent"
import { ISponsoredContentResult } from "providers/venue/types"

interface IUseRecommendedEventResult {
  recommendedEvents: ISponsoredContentResult
}

type IUseRecommendedEvent = () => IUseRecommendedEventResult

export const useRecommendedEvent: IUseRecommendedEvent =
  (): IUseRecommendedEventResult => {
    const { recommendedEvent: recommendedEvents } = useSponsoredContent()

    return {
      recommendedEvents,
    }
  }
